/**
 * Academic credential options for the lecturers-only marketplace.
 * Keys are stored in the DB; labels come from i18n (academic.degree.*,
 * academic.title.*). Experience is a plain number of years, filtered by ranges.
 */
export const DEGREE_KEYS = ["master", "phd", "doctor"];

export const TITLE_KEYS = ["assistant", "senior_lecturer", "docent", "professor"];

// Experience filter buckets → [minExp, maxExp] (undefined = open-ended).
export const EXPERIENCE_RANGES = [
  { id: "0_3", min: 0, max: 3 },
  { id: "3_5", min: 3, max: 5 },
  { id: "5_10", min: 5, max: 10 },
  { id: "10_plus", min: 10, max: undefined },
];

/**
 * Credential-verification flags for a tutor profile.
 * A degree/title gets the ✓ only while the shown value equals the value an
 * admin confirmed (editing it afterwards drops the ✓ automatically).
 * The full "Verified" badge needs identity verification AND confirmed education.
 */
export function credentialFlags(profile, isVerified) {
  const p = profile || {};
  const degreeVerified = !!p.verifiedDegree && p.verifiedDegree === p.degree;
  const titleVerified = !!p.verifiedTitle && p.verifiedTitle === p.academicTitle;
  const educationVerified = p.credentialStatus === "APPROVED" && (degreeVerified || titleVerified);
  return {
    degreeVerified,
    titleVerified,
    educationVerified,
    fullyVerified: !!isVerified && educationVerified,
  };
}
